"use strict";
// repeated in src/util/weather/Weather.ts
Object.defineProperty(exports, "__esModule", { value: true });
exports.ForecastPeriod = void 0;
var ForecastPeriod;
(function (ForecastPeriod) {
    ForecastPeriod["HOURLY"] = "HOURLY";
    ForecastPeriod["DAILY"] = "DAILY";
})(ForecastPeriod || (exports.ForecastPeriod = ForecastPeriod = {}));
/// Examples which dont belong in this file
